import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "linkUrl", "linkCategory", "linkItem"]

  connect() {
    this.toggle()
  }

  toggle() {
    this.togglePlacement()
    this.toggleLink()
  }

  togglePlacement() {
    const select = this.element.querySelector('[name="banner[placement]"]')
    if (!select || !this.hasCategoryTarget) return
    this.categoryTarget.classList.toggle("hidden", select.value !== "after_category")
  }

  toggleLink() {
    const select = this.element.querySelector('[name="banner[link_kind]"]')
    if (!select) return

    const kind = select.value
    if (this.hasLinkUrlTarget) this.linkUrlTarget.classList.toggle("hidden", kind !== "url")
    if (this.hasLinkCategoryTarget) this.linkCategoryTarget.classList.toggle("hidden", kind !== "category")
    if (this.hasLinkItemTarget) this.linkItemTarget.classList.toggle("hidden", kind !== "item")
  }
}
